'use client'

export const AUTHENTICATION_FAILURE_EVENT = 'vinc:authentication-failure'

export function emitAuthenticationFailureEvent(): void {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new CustomEvent(AUTHENTICATION_FAILURE_EVENT))
}
